import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SequenceSchemaType, TagSchemaSupportedFolderItemType} from 'constants/RegistryConstants';
import {TagSchemaSequenceSchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

import {TagSchemaSummaryGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';
import {
  DraftImplementedComplexPolymerInterface,
  isOligoConjugateImplementedInterface,
  isOligoDuplexImplementedInterface,
} from './ComplexPolymerSchemaInterfaceConstants';
import OligoConjugateConfigurationTable from './oligo-conjugates/OligoConjugateConfigurationTable';
import OligoDuplexConfigurationTable from './oligo-duplexes/OligoDuplexConfigurationTable';

export const EXTENDED_CONJUGATE_FOLDER_ITEM_TYPES: Array<
  TagSchemaSupportedFolderItemType | SequenceSchemaType
> = [
  ModelTypeConstants.MOLECULE,
  TagSchemaSequenceSchemaType.RNA_OLIGO,
  TagSchemaSequenceSchemaType.OLIGO,
  TagSchemaSequenceSchemaType.RNA_SEQUENCE,
];

export interface ComplexPolymerSchemaConfigurationProps {
  isWritable: boolean;
  complexPolymerConfig: DraftImplementedComplexPolymerInterface;
  onUpdateComplexPolymerConfig: (
    complexPolymerConfiguration: DraftImplementedComplexPolymerInterface
  ) => void;
  schemas: Array<TagSchemaSummaryGraphQL>;
}

export function sanitizeComplexPolymerConfig(
  complexPolymerConfig: DraftImplementedComplexPolymerInterface
): DraftImplementedComplexPolymerInterface {
  return isOligoDuplexImplementedInterface(complexPolymerConfig)
    ? {
        ...complexPolymerConfig,
        conjugatesSchemaFieldSpecs: complexPolymerConfig.conjugatesSchemaFieldSpecs ?? [],
      }
    : complexPolymerConfig;
}

export default function ComplexPolymerSchemaConfiguration(
  props: ComplexPolymerSchemaConfigurationProps
): JSX.Element {
  const onChange = (config: DraftImplementedComplexPolymerInterface): void => {
    props.onUpdateComplexPolymerConfig(sanitizeComplexPolymerConfig(config));
  };
  return (
    <div {...getTestProps({component: 'ComplexPolymerSchemaConfiguration', element: 'root'})}>
      {props.complexPolymerConfig != null && (
        <div className="u-moderate-spacing-top">
          {isOligoConjugateImplementedInterface(props.complexPolymerConfig) && (
            <OligoConjugateConfigurationTable
              oligoConjugateInterfaceImplementation={props.complexPolymerConfig}
              disabled={!props.isWritable}
              onChange={onChange}
              schemas={props.schemas}
            />
          )}
          {isOligoDuplexImplementedInterface(props.complexPolymerConfig) && (
            <OligoDuplexConfigurationTable
              oligoDuplexImplementedInterface={props.complexPolymerConfig}
              disabled={!props.isWritable}
              onChange={onChange}
              schemas={props.schemas}
            />
          )}
        </div>
      )}
    </div>
  );
}
